import { render, staticRenderFns } from "./AddOrPick.vue?vue&type=template&id=0a2d27c0&"
import script from "./AddOrPick.vue?vue&type=script&lang=js&"
export * from "./AddOrPick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports